import { Injectable } from '@angular/core';
import { AlertService } from '../alert-service/alert.service';
import { HttpClient } from '@angular/common/http';
import { IAPIResponse } from '@domain/interfaces/apis/api-response.interface';
import { catchError, map, Observable, of } from 'rxjs';
import { environment } from '@environments/environment';
import { AlertPosition, AlertType } from '@domain/enums/alert/alert-type.enum';
import { LoadingType } from '@domain/enums/alert/loading-type.enum';
import { ProductGateway } from '@domain/models/product/gateway/product.gateway';
import { FeatureProductEnum } from '@domain/enums/product/feature-product.enum';

@Injectable({
  providedIn: 'root',
})
export class ProductService extends ProductGateway {
  constructor(private _alertService: AlertService, private _http: HttpClient) {
    super();
  }
  public activateUpsell(userId: number, productFeature: FeatureProductEnum): Observable<IAPIResponse> {
    this._alertService.setLoading(true, LoadingType.Default, ['Activating product...']);
    return this._http.post<IAPIResponse>(`${environment.memberPortalServiceURL.replace('{{brandDomain}}', window.location.host)}/product/activate`, { userId: userId, featureProduct: productFeature }).pipe(
      map((apiResponse: IAPIResponse) => {
        this._alertService.setLoading(false);
        this._alertService.showAlert({
          type: apiResponse.responseCode == 121 ? AlertType.Success : AlertType.Error,
          title: apiResponse.responseCode == 121 ? 'Success' : 'Error',
          description: apiResponse?.message,
          position: AlertPosition.TopCenter,
        });
        return apiResponse;
      }),
      catchError((e) => {
        console.log(e);
        this._alertService.setLoading(false);
        this._alertService.showAlert({
          type: AlertType.Error,
          title: 'Error',
          description: e?.error?.Message,
          position: AlertPosition.TopCenter,
        });
        return of();
      })
    );
  }
}
